/**
 * The stash: a wall of lockers with a counter in front of them.
 *
 * On the left as the player comes in, beside the vendor, because the two things a returning raid
 * does are unload and sell and neither is worth a walk across the room from the other.
 *
 * Inert. What is inside is #207's, and until then this is four boxes and a hold that says so.
 */

import { stationPart } from '@/modes/hub/sim/stations/stationParts';
import type { HubStation } from '@/modes/hub/sim/stations/hubStationContract';
import type { StationFrame } from '@/modes/hub/sim/stations/stationParts';
import { vec3 } from '@/sim/vec3';

const FRAME: StationFrame = {
  kindId: 'stash',
  position: vec3(-11, 0, -4),
  yawDegrees: -90,
};

export const STASH_STATION: HubStation = {
  ...FRAME,
  colliders: [
    // Waist height, so it reads as something to put a bag down on rather than something to hide
    // behind. Well inside the step height at the foot, which is what keeps it from being climbed.
    stationPart(FRAME, 'counter', vec3(0, 0.5, -0.5), vec3(1.6, 0.5, 0.35), 'armourSteel'),
    stationPart(FRAME, 'lockersLeft', vec3(-1.1, 1.05, 0.2), vec3(0.5, 1.05, 0.35), 'armourSteel'),
    stationPart(FRAME, 'lockersRight', vec3(1.1, 1.05, 0.2), vec3(0.5, 1.05, 0.35), 'armourSteel'),
    stationPart(FRAME, 'crate', vec3(0, 0.28, 0.2), vec3(0.6, 0.28, 0.35), 'roughTimber'),
  ],
};
